import LittleDreamersBannerPreview from "../Previews/LittleDremers/banner-preview";
import LittleDremersPreview from "../Previews/LittleDremers/Preview";

export const littleDremers = {
    form: [
        {
            title: "Page Name",
            key: "page_name",
            className: "col-lg-12",
            type: "input",
        },
        {
            title: "Meta Description",
            key: "meta_description",
            className: "col-lg-12",
            type: "input",
        },
    ],
    component: [
        {
            type: 1,
            fields: [
                {
                    title: "English Page Image",
                    key: "image",
                    className: "col-lg-3",
                    placeholder: "Upload page image with a height of 1164 and a width of 2816",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
                {
                    title: "Simplified Chinese Page Image",
                    key: "image1",
                    className: "col-lg-3",
                    placeholder: "Upload page image with a height of 1164 and a width of 2816",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
                {
                    title: "Traditional Chinese Page Image",
                    key: "image2",
                    className: "col-lg-3",
                    placeholder: "Upload page image with a height of 1164 and a width of 2816",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
                {
                    title: "Bahasa Page Image",
                    key: "bahasa_image",
                    className: "col-lg-3",
                    type: "file",
                    withAlt: true,
                },
               {
                    title: "English Mobile Page Image",
                    key: "image3",
                    className: "col-lg-3",
                    placeholder: "Upload the mobile page image with a height of 240 and a width of 440",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
               {
                    title: "Simplified Chinese Mobile Page Image",
                    key: "image4",
                    className: "col-lg-3",
                    placeholder: "Upload the mobile page image with a height of 240 and a width of 440",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
                {
                    title: "Traditional Chinese Mobile Page Image",
                    key: "image5",
                    className: "col-lg-3",
                    placeholder: "Upload the mobile page image with a height of 240 and a width of 440",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
                {
                    title: "Bahasa Mobile Page Image",
                    key: "bahasa_image_mobile",
                    className: "col-lg-3",
                    type: "file",
                    withAlt: true,
                },
            ],
            preview: (activetab, cardData) => (
                <LittleDreamersBannerPreview activetab={activetab} cardData={cardData} />
            ),
        },
        {
            type: 3,
            fields: [
                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "English subtitle",
                    key: "subtitle",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese subtitle",
                    key: "simplified_chinese_subtitle",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese subtitle",
                    key: "traditional_chinese_subtitle",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa subtitle",
                    key: "bahasa_subtitle",
                    className: "col-lg-3",
                    type: "input",
                },

                {
                    title: "English Description",
                    key: "description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Simplified Chinese Description",
                    key: "simplified_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Traditional Chinese Description",
                    key: "traditional_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Bahasa Description",
                    key: "bahasa_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Banner Image",
                    key: "image",
                    className: "col-lg-6",
                    placeholder: "Upload Banner Image with a height of 1055 and a width of 1733",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
                {
                    title: "Mobile Banner Image",
                    key: "image2",
                    className: "col-lg-6",
                    placeholder: "Upload the mobile banner image with a height of 250 and a width of 260",
                    type: "file",
                    withAlt: true,
                    required: false,
                }
            ],
            level1: [
                {
                    title: "English Ship Title",
                    key: "ship_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Ship Title",
                    key: "simplified_chinese_ship_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Ship Title",
                    key: "traditional_chinese_ship_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Ship Title",
                    key: "bahasa_ship_title",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Ship Image",
                    key: "image",
                    className: "col-lg-12",
                    placeholder: "Upload ship image with a height of 90 and a width of 200",
                    type: "file",
                    withAlt: true,
                    required: false
                },
                {
                    title: "English Heading",
                    key: "heading",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Heading",
                    key: "simplified_chinese_heading",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Heading",
                    key: "traditional_chinese_heading",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Heading",
                    key: "bahasa_heading",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "English Ship Banner Image",
                    key: "image2",
                    className: "col-lg-3",
                    placeholder: "Upload ship banner image with a height of 1272 and a width of 2426",
                    type: "file",
                    withAlt: true,
                    required: false
                },
                {
                    title: "Simplified Chinese Ship Banner Image",
                    key: "image3",
                    className: "col-lg-3",
                    placeholder: "Upload ship banner image with a height of 1272 and a width of 2426",
                    type: "file",
                    withAlt: true,
                    required: false
                },
                {
                    title: "Traditional Chinese Ship Banner Image",
                    key: "image4",
                    className: "col-lg-3",
                    placeholder: "Upload ship banner image with a height of 1272 and a width of 2426",
                    type: "file",
                    withAlt: true,
                    required: false
                },
                {
                    title: "Bahasa Ship Banner Image",
                    key: "bahasa_image2",
                    className: "col-lg-3",
                    placeholder: "Upload ship banner image",
                    type: "file",
                    withAlt: true,
                },

                {
                    title: "English Note",
                    key: "note",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Note",
                    key: "simplified_chinese_note",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Note",
                    key: "traditional_chinese_note",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Note",
                    key: "bahasa_note",
                    className: "col-lg-3",
                    type: "input",
                },
            ],
            level2: [
                {
                    title: "Card Image",
                    key: "image",
                    className: "col-lg-12",
                    placeholder: "Upload card image with a height of 574 and a width of 574",
                    type: "file",
                    withAlt: true,
                    required: false
                },
                {
                    title: "English Sub Title",
                    key: "sub_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false
                },
                {
                    title: "Simplified Chinese Sub Title",
                    key: "simplified_chinese_sub_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false
                },
                {
                    title: "Traditional Chinese Sub Title",
                    key: "traditional_chinese_sub_title",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Bahasa Sub Title",
                    key: "bahasa_sub_title",
                    className: "col-lg-3",
                    type: "input",
                },

                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                },

                {
                    title: "English Description",
                    key: "description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Simplified Chinese Description",
                    key: "simplified_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Traditional Chinese Description",
                    key: "traditional_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Bahasa Description",
                    key: "bahasa_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "English filter text",
                    key: "filter_text",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Simplified Chinese filter text",
                    key: "simplified_chinese_filter_text",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Traditional Chinese filter text",
                    key: "traditional_chinese_filter_text",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Bahasa filter text",
                    key: "bahasa_filter_text",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "English Price",
                    key: "price",
                    className: "col-lg-3",
                    type: "input",

                },
                {
                    title: "Simplified Chinese Price",
                    key: "simplified_chinese_price",
                    className: "col-lg-3",
                    type: "input",

                },
                {
                    title: "Traditional Chinese Price",
                    key: "traditional_chinese_price",
                    className: "col-lg-3",
                    type: "input",

                },
                {
                    title: "Bahasa Price",
                    key: "bahasa_price",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "English tag",
                    key: "tag",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Simplified Chinese tag",
                    key: "simplified_chinese_tag",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Traditional Chinese tag",
                    key: "traditional_chinese_tag",
                    className: "col-lg-3",
                    type: "input",
                },
                {
                    title: "Bahasa tag",
                    key: "bahasa_tag",
                    className: "col-lg-3",
                    type: "input",
                },
            ],
            preview: (activetab, cardData) => (
                <LittleDremersPreview activetab={activetab} cardData={cardData} />
            ),
        },
    ],
};
